import { AdminModalName, AdminPanelName } from '../../../state';
import {
  loadPlaceRequest,
  pushAdminModal,
  pushAdminPanel,
} from '../../../actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAdminPlacesTableController = (place: {
  placeId: string;
  placeName: string;
}) => {
  const dispatch = useDispatch();

  const onDeleteClick = useCallback(
    () => dispatch(pushAdminModal(AdminModalName.DeletePlace, place)),
    [place],
  );

  const onEditClick = useCallback(() => {
    dispatch(loadPlaceRequest(place.placeId));
    dispatch(
      pushAdminPanel(AdminPanelName.Place, {
        placeKey: place.placeId,
      }),
    );
  }, [place.placeId]);

  return { onDeleteClick, onEditClick };
};
